// ABOUTME: Smart wrapper for the Quantity entity — owns useQuantityEntity and reports state via context.
// ABOUTME: Renders skeleton/error/form so the page no longer branches per entity.
import React from 'react'

import {useQuantityEntity} from '../hooks/useQuantityEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'
import {QuantityForm} from './QuantityForm'

export const QuantityEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, error, isSaving, actions} = useQuantityEntity({
    countryId: ctx.countryId,
    businessLine: ctx.businessLine,
    scopeId: ctx.selectedScopeId,
    pendingScope: ctx.pendingScope,
    rootScopeId: ctx.rootScopeId,
    fullLoadsAvailable: ctx.quantityOptions?.loadOptions?.fullLoadsAvailable !== false,
    loadBalanceAvailable: ctx.quantityOptions?.loadOptions?.loadBalanceAvailable !== false,
  })

  useRegisterEntityForm(actions, isSaving)

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <QuantityForm
      key={ctx.formResetKey}
      config={config}
      isReadOnly={ctx.isReadOnly}
      isCountryDefault={ctx.isCountryDefault}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
      options={ctx.quantityOptions}
    />
  )
}
